import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Page } from 'src/app/enums/enums';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  @Input() totalItems: number = 0; // Total number of items
  @Input() pageSize: number = Page.Size; // Default page size
  @Input() pageSizes: number[] = [15]; // Available page sizes
  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>(); // Page change event
  @Output() pageSizeChange: EventEmitter<number> = new EventEmitter<number>(); // Page size change event

  currentPage: number = 1;
  totalPages: number = 0;
  startItem: number = 0;
  endItem: number = 0;

  constructor() {}

  ngOnInit(): void {
    this.calculatePagination();
  }

  ngOnChanges(): void {
    this.calculatePagination();
  }

  calculatePagination(): void {
    // Calculate total number of pages
    this.totalPages = Math.ceil(this.totalItems / this.pageSize);

    // Calculate start and end items for the current page
    this.startItem = (this.currentPage - 1) * this.pageSize + 1;
    this.endItem = Math.min(this.totalItems, this.currentPage * this.pageSize);
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      this.goToPage(this.currentPage - 1);
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.goToPage(this.currentPage + 1);
    }
  }

  emitPageChange(): void {
    // this.calculatePagination();
    this.pageChange.emit(this.currentPage);
  }

  emitPageSizeChange(): void {
    this.pageSizeChange.emit(this.pageSize);
  }

  goToPage(page: number): void {
    if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
      this.currentPage = page;
      this.pageChange.emit(this.currentPage);
    }
  }

  onPageSizeChange(event: Event): void {
    const newSize = (event.target as HTMLSelectElement).value;
    this.pageSize = parseInt(newSize, 10);
    this.currentPage = 1; // Reset to first page when page size changes
    this.emitPageSizeChange();
  }

  getPageNumbers(): number[] {
    const totalDisplayedPages = 5; // Number of pages to display at a time
    const pages: number[] = [];

    // Always show the first page
    pages.push(1);

    // Show ellipsis before current page range if current page > 4
    if (this.currentPage > 4) {
      pages.push(-1); // -1 indicates an ellipsis in the template
    }

    // Display pages around the current page
    const startPage = Math.max(2, this.currentPage - 2);
    const endPage = Math.min(this.totalPages - 1, this.currentPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    // Show ellipsis after current page range if there are more pages
    if (this.currentPage < this.totalPages - 3) {
      pages.push(-1); // -1 indicates an ellipsis in the template
    }

    // Always show the last page
    if (this.totalPages > 1) {
      pages.push(this.totalPages);
    }

    return pages;
  }
}
